// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_k5-0";